'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('path', { d: 'M22 12l-4-4v3H3v2h15v3z' })
), 'TrendingFlat');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/TrendingFlat.js
// module id = 944
// module chunks = 0